<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="/static/logomaster.png" alt="MasterMedic" width="220" height="120">
                  <div class="v-alert v-alert--outline error--text" v-if="error"><i aria-hidden="true" class="v-icon material-icons v-alert__icon">warning</i><div>
                    {{ error }}.
                  </div></div>
                </div>                
                <v-form>
                  <v-text-field append-icon="person" name="login" label="E-mail" type="text" v-model="dadoslogin.email"
                  :rules="[rules.required, rules.email]"
                  >
                </v-text-field>
                <v-text-field append-icon="lock" name="password" label="Senha" id="password" type="password" v-model="dadoslogin.password"
                :rules="[rules.required]"
                 @keyup.enter="trigger">
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block color="primary" @click="logar" :loading="loading">Login</v-btn>

          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</v-content>
</v-app>
</template>

<script>
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
import {http, httpLogin} from '../../backend/vue-axios/axios';
export default {
  data: () => ({
    loading: false,
    dadoslogin: {
      email: '',
      password: ''
    },
    dadosUser:[],
    erros:[],
    error: false,
    rules: {
      required: (value) => !!value || 'Campo Obrigtório.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'E-mail inválido.';
      } 
    }, 
  }),

  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  methods: {


    logar () {
      this.loading = true;

      let data = JSON.stringify({
       email: this.dadoslogin.email,
       password: this.dadoslogin.password,
     })

      httpLogin.post('login', data)
      .then(request => this.loginSuccessful(request))
      .catch(() => this.loginFailed())
    },

    loginSuccessful (req) {
      if (!req.data.token) {
        this.loginFailed()
        return
      }

      if(req.data.user.role == 1){
        this.error = false
        localStorage.token = req.data.token
        localStorage.email = req.data.user.email
        localStorage.name = req.data.user.name
        this.$store.dispatch('login')
        this.$router.replace(this.$route.query.redirect || '/dashboard')
      }else if(req.data.user.role == 0){
        this.loading = false;
        this.error = 'Usuário não pode acessar este painel'
        this.$store.dispatch('logout') 
        delete localStorage.token
  }
},

loginFailed () {
    this.loading = false;
    this.error = 'Falhou Login!'
      this.$store.dispatch('logout')
      delete localStorage.token
  },

  trigger() {
    this.logar()
  }

}
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.primary{
  background-color: #007c6f !important;
}
.primary--text{
  color: #007c6f !important;

}

</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue